import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { withCookies } from 'react-cookie';
import { fontFamilyBody, fontFamilyHeading } from '../styles/helpers/mixins';
import { SUCCESS, FAILURE, LOADING, INITIAL } from '../constants/status';
import { LoadingSpinner } from './LoadingSpinner';
import { Conditional } from './Conditional';
import { SITE_ROOT_URL } from '../constants/endpoints';
import NewsletterSignUpForm from './NewsletterSignUpForm';

class NewsletterWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: INITIAL
    };

    this.setCookieToCloseModal = this.setCookieToCloseModal.bind(this);
    this.setStatus = this.setStatus.bind(this);
  }

  setCookieToCloseModal() {
    const { cookies } = this.props;
    const d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    cookies.set('newsletter_closed', true, { path: '/', expires: d });
  }

  setStatus(newStatus) {
    this.setState({
      status: newStatus
    });
  }

  render() {
    // if we did not get any data from backend, don't do anything else
    if (!window.newsletter) return null;

    // add hard coded data that is missing in backend
    window.newsletter = {
      errorHeadline: 'Ops!',
      errorBody: '<p>Något gick fel, vänligen försök igen.</p>',
      ...window.newsletter
    };

    const { cookies } = this.props;
    const { status } = this.state;
    const {
      active,
      title,
      body,
      successTitle,
      successText,
      errorHeadline,
      errorBody,
      inputEmailPlaceholder,
      image,
      confirmationText
    } = window.newsletter;

    // if any required data is missing, don't render the widget
    if (!active || !title || !body || !successTitle || !successText || !confirmationText) return null;

    // if the user has already closed the widget, don't render it again
    if (cookies.get('newsletter_closed')) return null;

    return (
      <NewsletterWidgetContainer hasImage={image && !!image.url}>
        <NewsletterWidgetContent>
          <Conditional show={status === LOADING}>
            <LoadingSpinner margin="66px auto !important" />
          </Conditional>

          <Conditional show={status === FAILURE}>
            <CenterContent>
              <NewsletterWidgetHeadline>{errorHeadline}</NewsletterWidgetHeadline>
              <NewsletterWidgetBody dangerouslySetInnerHTML={{ __html: errorBody }} />
            </CenterContent>
          </Conditional>

          <Conditional show={status === SUCCESS}>
            <CenterContent>
              <NewsletterWidgetHeadline>{successTitle}</NewsletterWidgetHeadline>
              <NewsletterWidgetBody dangerouslySetInnerHTML={{ __html: successText }} />
            </CenterContent>
          </Conditional>

          <Conditional show={status === INITIAL}>
            <NewsletterWidgetHeadline>{title}</NewsletterWidgetHeadline>
            <NewsletterWidgetBody dangerouslySetInnerHTML={{ __html: body }} />
            <NewsletterSignUpForm
              placeholder={inputEmailPlaceholder}
              privacyPolicy={confirmationText}
              onUpdateStatus={this.setStatus}
              onClose={this.setCookieToCloseModal}
            />
          </Conditional>
        </NewsletterWidgetContent>

        <Conditional show={image && !!image.url}>
          <NewsletterWidgetImage url={image && SITE_ROOT_URL + image.url} />
        </Conditional>

        <CloseButton onClick={this.setCookieToCloseModal}>
          <CloseButtonIcon src="/images/icons/close-white.svg" />
        </CloseButton>
      </NewsletterWidgetContainer>
    );
  }
}

NewsletterWidget.propTypes = {
  cookies: PropTypes.object.isRequired
};

export default withCookies(NewsletterWidget);

/*
  STYLES
*/

const CenterContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 207px;
`;

const NewsletterWidgetContainer = styled.div`
  max-width: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  height: auto;
  background-color: black;
  z-index: 100;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
  display: flex;

  @media screen and (min-width: 400px) {
    right: 20px;
    bottom: 20px;
    left: unset;
    width: 330px;
  }

  @media screen and (min-width: 680px) {
    right: 30px;
    bottom: 30px;
    left: unset;

    ${props =>
      props.hasImage &&
      css`
        width: 550px;
      `};
  }
`;

const NewsletterWidgetContent = styled.div`
  width: 100%;
  padding: 32px;

  @media screen and (min-width: 680px) {
    padding: 32px 25px 32px 32px;
  }
`;

const NewsletterWidgetHeadline = styled.h3`
  ${fontFamilyHeading};
  font-size: 32px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 0.25em;
`;

const NewsletterWidgetBody = styled.div`
  p {
    ${fontFamilyBody};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    margin-bottom: 1.5em;
  }
`;

const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
  border: none;

  &:focus {
    outline: 0;
  }
`;

const CloseButtonIcon = styled.img`
  height: 14px;
  width: 14px;
`;

const NewsletterWidgetImage = styled.div`
  display: none;
  min-width: 220px;
  min-height: 100%;
  background-image: url("${props => props.url}?width=440&heightratio=1.25&mode=crop");
  background-size: cover;
  
  @media screen and (min-width: 680px) {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/NewsletterWidget.js